module.exports = __webpack_public_path__ + "img/mastercard-logo.bda335ee.svg";